export const copyToClipboard = (element: HTMLElement | null) => {
  if (!element)
    return window.alert("We couldn't copy the data to the clipboard.");

  const selection = window.getSelection();

  if (selection === null)
    return window.alert("We couldn't copy the data to the clipboard.");

  const range = document.createRange();
  range.selectNodeContents(element);
  selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand("copy");
  selection.removeAllRanges();
};
